import { toast } from "react-toastify";

import { AUTH_NOTICE_MESSAGE } from "~/feature/auth/copy";
import type { AuthNotice } from "~/feature/auth/type";

export const showAuthNotice = (notice: AuthNotice): void => {
  toast.info(AUTH_NOTICE_MESSAGE[notice], {
    toastId: notice,
    theme: "dark",
    icon: false,
  });
};
